import { ApiUserData } from "src/models/user/ApiUserData"
import TieupImg from "../../../../common/TieupImg"
import Link from "next/link"
import routes from "routes"
import TruncateMarkup from "react-truncate-markup"

const Creator: React.FC<{ user: ApiUserData }> = ({ user }) => {
  return (
    <div className="p-novelSimplified">
      <div className="p-novelSimplified-row">
        <div className="p-creatorSimplified">
          <p className="p-creatorSimplified-title">作者情報</p>
          <div className="p-creatorSimplified-row">
            <div className="p-creatorSimplified-image">
              <TieupImg
                src={user.icon_url || "/img/user-icon.png"}
                alt={user.name}
              />
            </div>
            <div className="p-creatorSimplified-detail">
              <p className="p-creatorSimplified-name">{user.name}</p>
              <p className="p-creatorSimplified-id">{user.display_name}</p>
            </div>
          </div>
          {!!user.profile && (
            <TruncateMarkup lines={2}>
              <p className="p-creatorSimplified-profile">{user.profile}</p>
            </TruncateMarkup>
          )}
          {!!user.achievement_text && (
            <dl className="p-creatorSimplified-history">
              <dt className="p-creatorSimplified-history-label">
                <div className="p-creatorSimplified-history-label-inner">
                  経歴
                </div>
              </dt>
              <dd className="p-creatorSimplified-history-text">
                <div className="p-creatorSimplified-history-text-inner">
                  <TruncateMarkup lines={2}>
                    <p>{user.achievement_text}</p>
                  </TruncateMarkup>
                </div>
              </dd>
            </dl>
          )}
          <div className="p-button">
            <Link href={routes.creatorUser(user.display_name)}>
              <a className="c-button-secondary -outline -full">もっと見る</a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Creator
